import { render, staticRenderFns } from "./prescriptionDialog.vue?vue&type=template&id=50c91195&scoped=true"
import script from "./prescriptionDialog.vue?vue&type=script&lang=js"
export * from "./prescriptionDialog.vue?vue&type=script&lang=js"
import style0 from "./prescriptionDialog.vue?vue&type=style&index=0&id=50c91195&prod&lang=scss&scoped=true"
import style1 from "./prescriptionDialog.vue?vue&type=style&index=1&id=50c91195&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c91195",
  null
  
)

export default component.exports